<!-- <img class="close_button" (click)="closeDialog()" src="assets/images/Close_btn.svg"> -->

<div class="popup-container">
    <button mat-button mat-dialog-close (click)="closeDialog()" class="close black-button">X</button>

    <h2 class="p-3 mb-0 roboto-medium">AET Status Legend</h2>
    <hr id="shadow">
    <br>
    <div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="contents content_1">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Tracked For Impact</p>

        <div class="contents content_2">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Partial Tracked For Impact</p>
    </div>
    <br>


    <div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="contents content_3" >
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Missed Unload</p>

        <div class="contents content_4">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Partial Missed Unload</p>
    </div>
    <br>


    <div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="contents content_5">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Missed Next Connection</p>

        <div class="contents content_6">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>Partial Missed Next Connection</p>
    </div>
    <br>


    <div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="contents content_7">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>All Freight Moved To Resolution</p>

        <div class="contents content_8">
        </div>
        &nbsp;&nbsp;&nbsp;
        <p>	ETA is After the Plant Unload</p>
    </div>
    <br>

</div>